<template>
  <help-dialog title="AI Prompt" max-width="30%">
    <template #activator="{ props, openDialog }">
      <slot :props="props" :openDialog="openDialog"></slot>
    </template>

    <template #default>
      <h3 class="mb-1">Get AI assistance</h3>
      <p class="text-grey-darken-3">
        After entering a prompt, AI can help you create the following items:
      </p>
      <br />
      <ul class="pl-10 text-black">
        <li><b>Events</b></li>
        <li><b>Cards</b></li>
        <li><b>Commands</b></li>
        <li><b>Read Models</b></li>
        <li><b>Entities</b></li>
        <li><b>Code</b></li>
      </ul>

      <br /><br />

      <h3 class="mb-1">Enter the prompt</h3>
      <p class="text-grey-darken-3">
        Describe a business process or a project scope in natural language.
        For example: "<b>A process for ordering home delivery of food in 5 steps</b>".
      </p>
    </template>
  </help-dialog>
</template>

<script>
import HelpDialog from '@/components/HelpDialog.vue'

export default {
  components: {
    HelpDialog
  },
  props: ['openedFromSettings'],
  data () {
    return {
      open: false
    }
  }
}
</script>
